import { CSSProperties, FC, PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'
import { useFormContext } from 'react-hook-form'
import get from 'lodash/get'

import typeStyle from 'styles/typeStyle'

import ErrorMessage from './ErrorMessage'

const FieldWrapper = styled.div<{ marginBottom?: string }>`
  margin-bottom: ${({ marginBottom = '16px' }) => marginBottom};
`

const MessagesAndAnnotations = styled.div`
  display: flex;
  align-items: baseline;
`

export const Label = styled.label<{ error?: boolean }>`
  ${typeStyle('-ds-font-lead-sm')}
  display: block;
  line-height: 1;
  margin-bottom: 8px;
`

export type FieldProps = {
  name: string
  label?: ReactNode
  // eslint-disable-next-line react/no-unused-prop-types -- forwarded to TextField/SelectField wrappers
  autocomplete?: boolean
  annotations?: ReactNode
  // eslint-disable-next-line react/no-unused-prop-types -- forwarded to TextField/SelectField wrappers
  style?: CSSProperties
  skipErrorMessage?: boolean
  marginBottom?: string
}

const Field: FC<PropsWithChildren<FieldProps>> = ({
  name,
  label,
  annotations,
  skipErrorMessage = false,
  marginBottom,
  children,
}) => {
  const {
    formState: { errors },
  } = useFormContext()
  const error = get(errors, name)
  return (
    <FieldWrapper marginBottom={marginBottom}>
      {label && (
        <Label htmlFor={name} error={!!error}>
          {label}
        </Label>
      )}
      {children}
      <MessagesAndAnnotations>
        {!skipErrorMessage && <ErrorMessage name={name} />}
        <div style={{ marginLeft: 'auto' }}>{annotations}</div>
      </MessagesAndAnnotations>
    </FieldWrapper>
  )
}

export default Field
